import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamMetricsAppViewsSummaryAverageWholeTeamAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/summary/team-metrics-app-views-summary-average-whole-team.aggregate-root.mapper';
import { GetTeamMetricsAppViewsSummaryAverageWholeTeamRequestDto } from '../../../dtos/team-metrics/summary/get-team-metrics-app-views-summary-average-whole-team.request.dto';
import { GetTeamMetricsAppViewsSummaryResponseDto } from '../../../dtos/team-metrics/summary/get-team-metrics-app-views-summary.response.dto';
import { GetTeamMetricsAppViewsSummaryAverageWholeTeamQuery } from '../../../queries/team-metrics/summary/get-team-metrics-app-views-summary-average-whole-team.query';

export class GetTeamMetricsAppViewsSummaryAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsAppViewsSummaryAverageWholeTeamQuery,
    protected readonly mapper: TeamMetricsAppViewsSummaryAverageWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsAppViewsSummaryAverageWholeTeamRequestDto
  ): Promise<GetTeamMetricsAppViewsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetTeamMetricsAppViewsSummaryAverageWholeTeamController.get encountered an error: ${error}`
      );
    }
  }
}
